import React, { useMemo } from 'react';
import { MOBILE_ISSUE } from '@atlassian/jira-common-constants/src/analytics-sources.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	useAnalyticsSource,
	useProjectKey,
	useIssueKey,
} from '@atlassian/jira-issue-context-service/src/main.tsx';
import { useFieldConfig } from '@atlassian/jira-issue-field-base/src/services/field-config-service/main.tsx';
import { TIME_TRACKING_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { useProjectPermissions } from '@atlassian/jira-project-permissions-service/src/main.tsx';
import { useTimeTrackingConfiguration } from '@atlassian/jira-settings-service/src/main.tsx';
import { LogWork, label as logWorkLabel } from '../add-to-issue-dropdown-group/log-work/index.tsx';

export const LogWorkDropdownGroup = (
	onClick: (
		itemKey: string,
		event?: Event,
		actionAttributes?: Attributes,
	) => Promise<undefined> | undefined,
) => {
	const { formatMessage } = useIntl();
	const source = useAnalyticsSource();
	const issueKey = useIssueKey();
	const projectKey = useProjectKey();
	const [permissions] = useProjectPermissions(projectKey);
	const [timeTrackingFieldConfigData] = useFieldConfig(issueKey, TIME_TRACKING_TYPE);
	const timeTrackingFieldConfig = timeTrackingFieldConfigData.value;
	const [timeTrackingConfig] = useTimeTrackingConfiguration();

	const canLogTime = useMemo(
		() =>
			source !== MOBILE_ISSUE &&
			permissions.canLogWork &&
			!!timeTrackingFieldConfig &&
			timeTrackingConfig.isTimeTrackingEnabled,
		[source, permissions, timeTrackingFieldConfig, timeTrackingConfig],
	);
	return {
		name: '',
		key: 'LogWorkDropdownGroup',

		items: [
			...(canLogTime
				? [
						<LogWork
							key="logWork"
							onClick={onClick}
							label={formatMessage(logWorkLabel)}
							itemKey="logWork"
						/>,
					]
				: []),
		],
	};
};
